import React, { useEffect, useState } from "react";
import API from "util/Api";
import { DialogForm } from "components/PopUpDialog";
import SnackBar from "components/SnackBar";
import * as Yup from "yup";

const ResetDialog = ({ dialog, setDialog, setLoopData }) => {
    const fields = [
        {
            "value": "",
            "title": "Vehicle Count",
            "key": "count",
            "help": "",
            "type": "input",
            "size": "6",
            "hidden": false,
            "disabled": false
        }
    ];
    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });


    const validation = Yup.object().shape({
        count: Yup.number().required("Required"),
    });

    const handleSubmit = (data) => {
        API.post(`loopDataReset`, JSON.stringify({ ...data, ...dialog.data }))
            .then((res) => {
                setDialog({ open: false });
                setLoopData(res.data.data);
                setSnackBar({
                    open: true,
                    message: res.data.msg,
                    type: "success",
                });
            })
            .catch((err) => {
                console.log("error", err);
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ?? "Something went wrong",
                    type: "error",
                });
            });
    }

    return (
        <>
            <DialogForm
                open={dialog.open}
                header="Reset Loop Data"
                maxWidth="sm"
                fields={fields}
                validationSchema={validation}
                onClose={() => {
                    setDialog({ open: false })
                }}
                onSubmit={handleSubmit}
            />
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar(prevState => ({ ...prevState, open: false, message: "" }));
                }}
            />
        </>)
}
export default ResetDialog;